import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { UserApiService } from 'src/app/dashboard/services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { Dropdown } from 'src/app/models/dropdown';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
})
export class DropDownComponent {
  @Input() dropDownData!: any[];
  @Input() addUrl?: string;
  @Input() relationId?: string;
  @Input() relationName?: string;
  @Input() fieldName?: string[];
  @Input() staticItems?: any;
  @Input() ngModelValue: any;
  @Input() isValid?: boolean;
  @Input() isDisable?: boolean;
  @Input() buttonClass?: string;
  @Input() defaultValue?: string;
  @Output() ngModelValueChange = new EventEmitter<any>();

  @ViewChild('SearchInput') searchElement!: ElementRef;

  constructor(
    private logger: LoggerService,
    private renderer: Renderer2,
    private apiService: UserApiService
  ) {
    if (this.dropDownData == null) {
      this.dropDownData = [];
    }

    if (!this.isValid) {
      this.isValid = true;
    }

    if (!this.isDisable) {
      this.isDisable = false;
    }

    this.showData = this.dropDownData.map((current) => ({
      id: current.id,
      friendlyName: current.name,
    }));

    if (!this.defaultValue) {
      this.selectedItem = new Dropdown('', `یک گزینه را انتخاب کنید`);
    } else {
      this.selectedItem = this.findDefaultValue();
    }
  }

  public showData: Dropdown[];

  public selectedItem: Dropdown;

  public listClosed: boolean = true;

  public loading: boolean = false;

  public searchBox: string = '';

  public NewName: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['dropDownData'] &&
      changes['dropDownData'].currentValue !== undefined
    ) {
      const newData = changes['dropDownData'].currentValue;

      if (newData && newData.length > 0) {
        this.showData = newData.map((current) => ({
          id: current.id,
          friendlyName: current.persianName,
        }));

        this.selectedItem = this.findDefaultValue();
      }
    }

    if (
      changes &&
      changes['defaultValue'] &&
      changes['defaultValue'].currentValue !== undefined
    ) {
      this.findDefaultValue();
    }

    if (
      changes &&
      changes['isDisable'] &&
      changes['isDisable'].currentValue !== undefined
    ) {
      const newData = changes['isDisable'].currentValue;
      this.listClosed = true;
    }
  }

  public searchOnItems() {
    if (this.searchBox == null || this.searchBox == '') {
      this.showData = this.dropDownData.map((current) => ({
        id: current.id,
        friendlyName: current.persianName,
      }));
    } else {
      const lowerCaseSearchBox = this.searchBox.toLowerCase();
      const splitSearchBox = lowerCaseSearchBox.split(' ');

      this.showData = this.dropDownData
        .filter((current) => current.persianName != null)
        .filter((current) => {
          const lowerCasePersianName = current.persianName.toLowerCase();
          return splitSearchBox.every((word) =>
            lowerCasePersianName.includes(word)
          );
        })
        .map((current) => ({
          id: current.id,
          friendlyName: current.persianName,
        }));
    }
  }

  public emptySearch() {
    this.searchBox = '';
    this.searchOnItems();
  }

  public selectItem(item) {
    this.selectedItem = item;
    this.listClosed = true;
    this.ngModelValueChange.emit(this.selectedItem);
  }

  public addButton() {
    try {
      if (!this.addUrl || this.addUrl == '') {
        return;
      }

      if (this.NewName == null || this.NewName == '') {
        return;
      }

      const regexBarcode: RegExp = /^([آ-ی]|[a-z]|[A-Z]| ){3,}$/;
      if (!regexBarcode.test(this.NewName)) {
        this.logger.addError(
          'در این ثبت فقط میتوانید از حروف استفاده کنید',
          false
        );
        return;
      }

      var backentJson = {};

      if (this.fieldName == null) {
        backentJson['name'] = this.NewName;
        backentJson['persianName'] = this.NewName;
      } else {
        if (this.fieldName.length == 1) {
          backentJson[this.fieldName[0]] = this.NewName;
        } else {
          const splitItems = this.NewName.split(' ');

          if (splitItems.length < 2) {
            this.logger.addError(
              'برای ایجاد یک آیتم باید دو کلمه با یک فاصله وارد نمایید ',
              false
            );
            return;
          }
          for (let index = 0; index < this.fieldName.length; index++) {
            const element = this.fieldName[index];
            backentJson[element] = splitItems[index];
          }
        }
      }

      if (this.relationId != null && this.relationName != null) {
        backentJson[this.relationName] = this.relationId;
      }

      if (this.staticItems != null) {
        for (const [key, value] of Object.entries(this.staticItems)) {
          backentJson[key] = value;
        }
      }

      this.apiService
        .postItem(new ApiRequestModel(this.addUrl, backentJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.showData.push(new Dropdown(result.data.id, this.NewName));
              this.NewName = '';
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            if (error.error.errorMessages != undefined) {
              this.logger.addListError(error.error.errorMessages);
            } else {
              this.logger.addError('ConnectionError', false);
              this.loading = false;
            }
          },
          () => {
            this.loading = false;
          }
        );
    } catch (error) {}
  }

  public openDropDown() {
    if (!this.isDisable) {
      this.listClosed = !this.listClosed;
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 2);
    }
  }

  public onClickedOutside() {
    this.listClosed = true;
  }

  public findDefaultValue(): Dropdown {
    let viewModel = new Dropdown('', `یک گزینه را انتخاب کنید`);

    if (
      this.showData == null ||
      this.showData.length == 0 ||
      this.defaultValue == null
    ) {
      return viewModel;
    }

    const foundedItem = this.showData.find(
      (current) => current.id == this.defaultValue
    );

    if (foundedItem == null) {
      return viewModel;
    }

    this.selectItem(foundedItem);
    return foundedItem;
  }
}
